<template>
  <div class="flex flex-col gap-2 p-2 bg-gray-100 !shadow-lg w-full">
    <div class="flex flex-row">
      <div class="w-1/5">
        <input
          ref="pdfUploadInput"
          type="file"
          name="pdfUpload"
          hidden
          @change="handleFileSelected"
        />
        <Button class="rounded-md p-2"
          color="blue"
          @click="chooseFile()">
          Upload PDF
        </Button>
      </div>
      <div class="flex-grow flex items-center justify-between gap-4 px-2">
        <div v-if="pdfData?.fileName">
          <span class="pr-3">Last File Uploaded:</span>
          <span>{{ pdfData.fileName }}</span>
        </div>
        <div v-if="pdfData?.timestamp">
          <span class="pr-3">Uploaded On:</span>
          <span>{{ timestampDisplay }}</span>
        </div>
      </div>
    </div>
    <div class="flex flex-col bg-white p-2"
      v-if="pdfData !== undefined">
      <div class="pb-4">
        <div class="flex flex-row text-gray-400 uppercase border-b-2 items-center">
          <Spinner class="pb-2"
            v-if="pdfData?.status === 'P'"
            :size="4"
          />
          <span>{{ STATUS_DISPLAY[pdfData.status] }}</span>
        </div>
      </div>
      <!-- <div>{{ pdfData.content }}</div> -->
      <div class="flex justify-center">
        <Button class="rounded-md p-2"
          color="gray"
          :disabled="pdfData.status !== 'C'"
          @click="populateFormClick()">
          Populate Form
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '../components/Button.vue'
import Spinner from './Spinner.vue'

import newStudentPdfUploadService from '../services/pdfUpload/newStudentPdf.js'

import cloneDeep from 'clone-deep'


const SERVER_STATUS_REMAP = {
  'P': 'P',
  'R': 'P',
  'C': 'C',
  'E': 'E',
}

export default {
  components: {
    Button,
    Spinner,
  },
  props: {},
  data() {
    return {
      user: undefined,
      view: undefined,

      STATUS_DISPLAY: {
        'P': 'Processing',
        'E': 'Error',
        'C': 'Ready',
      },

      pdfData: undefined,
      service: newStudentPdfUploadService,
    }
  },
  eventCallbackIds: {},
  methods: {
    setService(updatedService) {
      this.service = updatedService
      this.prepareCallbacks()
    },
    prepareCallbacks() {
      this.service.setStatusChangeCallback((newStatus) => {
        if (newStatus) {
          this.pdfData.status = SERVER_STATUS_REMAP[newStatus]
        }
        else {
          this.pdfData = undefined
        }
      })
      this.service.setContentReadyCallback((pdfData) => {
        this.$set(this.pdfData, 'content', pdfData.content)
      })
    },
    clearCallbacks() {
      this.service.setStatusChangeCallback(undefined)
      this.service.setContentReadyCallback(undefined)
    },
    loadExistingPdfUpload() {
      if (this.service.exists('new_student')) {
        this.pdfData = cloneDeep(this.service.getData())
        this.pdfData.status = SERVER_STATUS_REMAP[this.pdfData.status]
      }
    },
    chooseFile() {
      this.$refs.pdfUploadInput.click()
    },
    async handleFileSelected(event) {
      const pdfUploadInput = event.target
      const selectedFile = pdfUploadInput.files[0]
      console.log(this.$refs.pdfUploadInput.files[0])

      if (selectedFile) {
        var timestamp = new Date()
        try {
          await this.service.uploadPdf(selectedFile, 'new_student', timestamp)
        }
        catch {
          // do nothing
        }
        this.$refs.pdfUploadInput.value = null
        this.displayUploadData(selectedFile, timestamp)
      }
    },
    displayUploadData() {
      this.pdfData = cloneDeep(this.service.getData())
    },
    populateFormClick() {
      this.$emit('populateForm', this.pdfData.content)
    }
  },
  computed: {
    timestampDisplay() {
      return this.pdfData.timestamp.toLocaleString(
        'en-US',
        {
          minute: '2-digit',
          hour: '2-digit',
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        }
      )
    }
  },
  async mounted() {
    this.prepareCallbacks()
    this.loadExistingPdfUpload()
  },
  created() {
    // this.$options.eventCallbackIds.uiDataUpdated = events.register(
    //   'uiDataUpdated',
    //   () => {
    //     this.serveUiData()
    //   }
    // )
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    this.clearCallbacks()
    // events.remove(
    //   'uiDataUpdated',
    //   this.$options.eventCallbackIds.uiDataUpdated
    // )
  },
}
</script>
